import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField, { InputDateField } from '../../../../utils/InputField';
import { handleModifyVersionInfoOpe } from '../SubscriptionsDetailsOpe';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';

function ModifyVersionInfo({ data, closeModal }) {
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const { setMessage } = useTemplate();
    const { handleReload } = useSubscriptionsDetails();
    const { id, timeFirstInstallation, installedVersion, currentVersion } = data;
    const [formData, setFormData] = useState({
        DateFirstInstallation: timeFirstInstallation
            ? dayjs(timeFirstInstallation * 1000).format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD'),
        InstalledVersion: installedVersion || '',
        CurrentVersion: currentVersion || ''
    });
    const handleOnChange = (ev) => {
        const { name, value } = ev.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    const handleOnSubmit = (ev) => {
        ev?.preventDefault();
        setLoading(true);
        handleModifyVersionInfoOpe(id, formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                closeModal(false);
                setMessage({ type: 'success', text: title });
                handleReload();
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err?.toString(0) });
            });
    };
    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleOnSubmit} className="flex flex-col gap-3">
            <InputDateField
                label="First Installation"
                name="DateFirstInstallation"
                formData={formData}
                onChange={handleOnChange}
                required
            />
            <InputField
                label="Installed Version"
                name="InstalledVersion"
                formData={formData}
                onChange={handleOnChange}
                required
            />
            <InputField
                label="Current Version"
                name="CurrentVersion"
                formData={formData}
                onChange={handleOnChange}
                required
            />
            <div className="flex justify-end gap-2.5">
                <ButtonCancel title="cancel" onClick={closeModal} />
                <ButtonPrimary title="Save" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default ModifyVersionInfo;
